import { Component } from "@theme/component";

/**
 *
 * @template {import('@theme/component').Refs} [Refs = {}]
 *
 * @extends Component<Refs>
 */

if (!customElements.get("rug-quiz")) {
    class RugQuiz extends Component {
        connectedCallback() {
            this.filterText = "";
            this.answers = new Map();
            this.currentStep = parseInt(this.getAttribute("current-step"), 10);
            this.addEventListener("change", this.handleSelect.bind(this));
            this.nextButtons.forEach((button) => {
                button.addEventListener("click", this.handleNext.bind(this));
            });
            this.skipButtons.forEach((button) => {
                button.addEventListener("click", this.handleSkip.bind(this));
            });
            this.backButton.addEventListener(
                "click",
                this.handleBack.bind(this),
            );
            window.dataLayer.push({
                event: "rug_finder_start",
            });

            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "current-step") {
                        const currentStep = parseInt(
                            this.getAttribute("current-step"),
                            10,
                        );
                        const willShowElement =
                            this.blockWrapper?.children[currentStep];
                        for (const child of this.blockWrapper.children) {
                            child.style.display = "none";
                        }

                        willShowElement.style.display = "block";
                        this.stepInfo.textContent = String(currentStep + 1);
                        this.style.setProperty("--rug-quiz-step", String(currentStep + 1));
                        const skipButton =
                            willShowElement.querySelector(".skip-button");
                        const nextButton =
                            willShowElement.querySelector(".next-button");
                        if (
                            currentStep + 1 ===
                            this.blockWrapper?.children?.length
                        ) {
                            skipButton.style.display = "none";
                            nextButton.style.display = "inline-flex";
                            const nextLabel = nextButton.querySelector("[data-next-label]");
                            if (nextLabel) nextLabel.textContent = "Show Matching Rugs";
                        } else {
                            skipButton.style.display = "inline-flex";
                        }
                        if (currentStep < 1) {
                            this.backButton.style.display = "none";
                        }
                    }
                });
            });

            observer.observe(this, { attributes: true });
        }

        handleSelect(e) {
            if (!(e.target instanceof HTMLElement)) return;
            const currentElement = this.blockWrapper.children[this.currentStep];
            let newQueryText = currentElement.getAttribute("query-text") ?? "";
            const inputLi = e.target.closest("li");
            if (!inputLi) return;
            const input = inputLi.querySelector("input[type='checkbox']");
            if (!input) return;
            const isMulti = currentElement.getAttribute("is-multi") === "true";
            const filterValue = input.value || "";
            const answer = {
                step: this.currentStep + 1,
                answer: inputLi.dataset.answer || "",
                filters: filterValue,
            };
            const nextButton = currentElement.querySelector(".next-button");
            window.brEvents?.publish("rug_finder_answered", {
                step: this.currentStep + 1,
                answer: filterValue,
                multi: isMulti,
                selected: input.checked,
            });

            if (isMulti) {
                inputLi.classList.toggle("is-chosen", input.checked);
                if (input.checked) {
                    this.filterText += filterValue;
                    newQueryText += filterValue;
                    this.answers.set(filterValue, answer);
                } else {
                    this.filterText = this.filterText.replace(filterValue, "");
                    newQueryText = newQueryText.replace(filterValue, "");
                    this.answers.delete(filterValue);
                }

                if (newQueryText?.length > 0) {
                    nextButton.style.display = "inline-flex";
                } else {
                    if (
                        this.currentStep + 1 <
                        this.blockWrapper?.children?.length
                    )
                        nextButton.style.display = "none";
                }
                currentElement.setAttribute("query-text", newQueryText);
            } else {
                const previous = currentElement.getAttribute("query-text") ?? "";
                if (previous) {
                    this.filterText = this.filterText.replace(previous, "");
                    this.answers.delete(previous);
                }
                currentElement
                    .querySelectorAll(".rug-quiz__item.is-chosen")
                    .forEach((item) => item.classList.remove("is-chosen"));
                inputLi.classList.add("is-chosen");
                currentElement.setAttribute("query-text", filterValue);
                this.filterText += filterValue;
                this.answers.set(filterValue, answer);
                this.handleNext();
            }

        }

        handleBack() {
            if (this.currentStep < 1) return;
            this.currentStep -= 1;
            this.setAttribute("current-step", this.currentStep);
        }

        handleNext() {
            if (this.currentStep + 1 === this.blockWrapper?.children?.length) {
                const textToArray = this.filterText.split("&");
                const uniqeArray = [...new Set(textToArray)];
                const newFilterText = uniqeArray.join("&");
                const target =
                    "https://boutiquerugs.com/collections/area-rugs?" +
                    newFilterText;
                let left = false;
                const leave = () => {
                    if (left) return;
                    left = true;
                    window.location.href = target;
                };

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "rug_finder_results",
                    filters: newFilterText,
                    answers: [...this.answers.values()],
                    eventCallback: () => setTimeout(leave, 300),
                    eventTimeout: 1500,
                });
                setTimeout(leave, 1500);
                return;
            }
            this.currentStep += 1;
            this.setAttribute("current-step", this.currentStep);
            if (this.currentStep < 1) {
                this.backButton.style.display = "none";
            } else {
                this.backButton.style.display = "inline-flex";
            }
        }

        handleSkip() {
            window.brEvents?.publish("rug_finder_answered", {
                step: this.currentStep + 1,
                skipped: true,
            });
            this.currentStep += 1;
            this.setAttribute("current-step", this.currentStep);
        }

        get blockWrapper() {
            return this.querySelector(".blocks__wrapper");
        }

        get questionGroup() {
            return this.querySelector(".blocks__wrapper")?.children;
        }

        get backButton() {
            return this.querySelector('button[name="back-step"]');
        }

        get stepInfo() {
            return this.querySelector("#step-info span");
        }

        get nextButtons() {
            return this.querySelectorAll(".next-button");
        }

        get skipButtons() {
            return this.querySelectorAll(".skip-button");
        }
    }
    customElements.define("rug-quiz", RugQuiz);
}
